import { useState } from 'react';
import { getSignedUrls } from '@/network/api.service';
import { toast } from 'sonner';
import resizeTo1080p from './image-resize';

const BASE_FOLDER = import.meta.env.APP_ENV === 'production' ? 'production' : 'staging';

export function useMediaUploader({ folder }) {
  const [localMedia, setLocalMedia] = useState([]); // File + preview
  const [uploadedMedia, setUploadedMedia] = useState([]); // final DB-ready objects
  const [uploading, setUploading] = useState(false);

  const reset = () => {
    setLocalMedia([]);
    setUploadedMedia([]);
  };

  /* Add files (preview only) */
  const addFiles = async (files, type) => {
    // const prepared = Array.from(files).map(file => ({
    //   id: crypto.randomUUID(),
    //   file,
    //   type,
    //   preview: URL.createObjectURL(file),
    // }));
    const prepared = await Promise.all(
      Array.from(files).map(async file => {
        let finalFile = file;

        if (file.type.startsWith('image/')) {
          finalFile = await resizeTo1080p({
            file,
            maxLongSide: 1920,
            quality: 0.75,
          });
        }

        return {
          id: crypto.randomUUID(),
          file: finalFile,
          type,
          preview: URL.createObjectURL(finalFile),
        };
      })
    );

    setLocalMedia(prev => [...prev, ...prepared]);
  };

  /* Remove media */
  const removeMedia = id => {
    setLocalMedia(prev => prev.filter(m => m.id !== id));
    setUploadedMedia(prev => prev.filter(m => m._tempId !== id));
  };

  /* Upload all pending media */
  const uploadAll = async () => {
    if (!localMedia.length) return uploadedMedia;

    try {
      setUploading(true);

      const filesPayload = localMedia.map(m => ({
        id: m.id,
        fileName: m.file.name,
        contentType: m.file.type,
      }));
      const res = await getSignedUrls({ files: filesPayload, folder: `${BASE_FOLDER}/${folder}` });

      if (!res?.data?.data?.length) throw new Error('Signed URL failed');

      await Promise.all(
        res.data.data.map((signed, idx) => {
          return fetch(signed.uploadUrl, {
            method: 'PUT',
            // headers: { 'Content-Type': localMedia[idx].file.type },
            // headers: { 'Content-Type': signed.contentType },
            body: localMedia[idx].file,
          });
        })
      );

      const uploaded = res.data.data.map((f, idx) => ({
        filename: f.filename,
        public_url: f.public_url,
        bucket: f.bucket,
        path: f.filePath,
        mime_type: localMedia[idx].type,
        uploaded_at: new Date(),
      }));

      setUploadedMedia(prev => [...prev, ...uploaded]);
      setLocalMedia([]);

      return [...uploadedMedia, ...uploaded];
    } catch (e) {
      console.error(e);
      toast.error('Media upload failed');
      return uploadedMedia;
    } finally {
      setUploading(false);
    }
  };

  return {
    localMedia,
    uploadedMedia,
    uploading,
    addFiles,
    removeMedia,
    uploadAll,
    reset,
    setLocalMedia,
    setUploadedMedia,
  };
}
